import React, {type FC} from 'react'
import clsx from 'clsx'
import type {TextProps} from './types'
import styles from './Text.scss'

export const Text: FC<TextProps> = (props) => {
  const {children, type, color, noMargin = false, className} = props
  return (
    <div className={clsx(
      styles.wrap,
      styles[`wrap__${type}`],
      styles[`wrap__${type}__${color}`],
      noMargin && styles.noMargin,
      className,
    )}
    >{children}</div>
  )
}
